import { Component, HostBinding } from '@angular/core';
import { ButtonComponent } from '../core/button.component';

@Component({
  selector: 'spb-circular-button',
  templateUrl: './circular-button.component.html',
})
export class CircularButtonComponent extends ButtonComponent {
  @HostBinding('class.spb-circular-button') hostBaseClass = true;
}
